import { Component, OnInit, OnDestroy, EventEmitter, Output, Input, HostListener, ElementRef, ViewChild, TemplateRef, VERSION } from '@angular/core';
import { NavEntity } from 'src/app/models/general/nav-entity.interface';
import { UserValuesService } from 'src/app/services/utils/user-values.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/services/utils/snackBar.service';
import { getNavMenuList } from 'src/app/models/const/nav-const';
import { UserHubService } from 'src/app/services/utils/user-hub.service';

@Component({
  selector: 'app-menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss']
})
export class MenuNavComponent implements OnInit, OnDestroy {

  private readonly iconByKeyword: Array<[RegExp, string]> = [
    [/jornadas habituales/i, 'schedule'],
    [/jornadas programadas/i, 'event'],
    [/avisos/i, 'notifications'],
    [/justificaciones/i, 'fact_check'],
    [/vacaciones/i, 'beach_access'],
    [/parte diario/i, 'today'],
    [/novedades de liquidaci/i, 'payments'],
    [/hs extras|autorizaciones/i, 'approval'],
    [/abm sistema/i, 'memory'],
    [/abm estructuras/i, 'account_tree'],
    [/abm novedades/i, 'campaign'],
    [/abm personas/i, 'manage_accounts'],
    [/individuales|informes|tableros/i, 'bar_chart'],
    [/generales/i, 'bar_chart'],
    [/calendarizados/i, 'calendar_month'],
    [/visor de novedades|timeline/i, 'timeline'],
    [/nómina|nomina/i, 'groups'],
    [/soporte/i, 'support_agent'],
    [/sniper/i, 'gps_fixed'],
    [/inicio|home/i, 'home'],
    [/config/i, 'settings'],
    [/sistema/i, 'memory'],
    [/novedad/i, 'campaign'],
    [/liquidaci/i, 'request_quote'],
    [/reporte/i, 'assessment'],
    [/registro.*cambio|historial/i, 'history'],
    [/instructivo|ayuda/i, 'menu_book'],
    [/usuario|perfil/i, 'manage_accounts'],
  ];

  @Output() HomeMenu_LoginAccion_prm = new EventEmitter();
  @Output() HomeMenu_ComponentShow_prm = new EventEmitter();
  idRol: number;
  navMenuList: Array<NavEntity> = [];
  userLabel: any;

  @Input() public set HomeMenu_SetOpcionesXRol_void(IdRol: number) {
    this.Set_HomeMenuXRol(IdRol);
  }

  isExpanded = false;
  desktopMenusSuppressed = false;
  currentUrl = '';
  @Input() buildDate: Date;
  readonly angularVersion = VERSION.full;
  readonly backendVersion = '10.0';
  private expandedMenuItems = new Set<NavEntity>();
  private routerSubscription: Subscription;
  @ViewChild('mobileMenuToggle') private mobileMenuToggle: ElementRef;
  @ViewChild('aboutDialog') private aboutDialog: TemplateRef<unknown>;
  private aboutDialogRef: MatDialogRef<unknown>;
  private aboutTriggerElement: HTMLElement;

  constructor(
    private userValuesService: UserValuesService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private _snackBar: SnackBarService,
    private _userHubService: UserHubService,
    private dialog: MatDialog) {
    // BACKUP MENU
    // this.navMenuList = getNavMenuList(this.userValuesService.getUsuarioValues.IdRol, this.userValuesService.getUsuarioValues.IdUsuario);
    this.navMenuList = this.userValuesService.getUsuarioValues.SistMenu ?
      JSON.parse(this.userValuesService.getUsuarioValues.SistMenu) : null;
    if (!this.navMenuList) {
      this.cerrarSesion();
    }
  }

  ngOnInit() {
    this.Set_HomeMenuXRol(this.userValuesService.getUsuarioValues.IdRol);
    this.userLabel = this.userValuesService.getUsuarioValues.NomUsuario;
    this.currentUrl = this.route.url;
    this.routerSubscription = this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        if (this.isExpanded) {
          this.closeMobileMenu();
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.setPageScrollLocked(false);
  }

  toggleNavbar() {
    if (this.isExpanded) {
      this.closeMobileMenu();
    } else {
      this.isExpanded = true;
      this.setPageScrollLocked(true);
      this.expandActiveMenuGroups();
    }
  }

  selectMenuItem(event: Event, item: NavEntity) {
    if (item.disabled) {
      event.preventDefault();
      return;
    }

    if (!this.hasVisibleSubmenu(item)) {
      this.closeMobileMenu();
      if (window.innerWidth >= 1100) {
        this.closeDesktopMenus();
      }
      return;
    }

    event.preventDefault();
    if (window.innerWidth >= 1100) {
      return;
    }

    const siblings = this.findMenuSiblings(this.navMenuList || [], item) || [];
    const siblingAlreadyExpanded = siblings.some(sibling => sibling !== item && this.expandedMenuItems.has(sibling));
    if (siblingAlreadyExpanded) {
      siblings.forEach(sibling => {
        if (sibling !== item) {
          this.expandedMenuItems.delete(sibling);
          this.removeExpandedDescendants(sibling);
        }
      });
      this.expandedMenuItems.add(item);
    } else if (this.expandedMenuItems.has(item)) {
      this.expandedMenuItems.delete(item);
      this.removeExpandedDescendants(item);
    } else {
      siblings.forEach(sibling => {
        if (sibling !== item) {
          this.expandedMenuItems.delete(sibling);
          this.removeExpandedDescendants(sibling);
        }
      });
      this.expandedMenuItems.add(item);
    }
  }

  closeMobileMenu(restoreFocus = true) {
    const wasExpanded = this.isExpanded;
    this.resetMobileMenu();
    if (restoreFocus && wasExpanded && this.mobileMenuToggle) {
      this.mobileMenuToggle.nativeElement.focus();
    }
  }

  private closeDesktopMenus() {
    this.desktopMenusSuppressed = true;
    const active = document.activeElement as HTMLElement | null;
    if (active && active.closest('#MenuHeader')) {
      active.blur();
    }
  }

  resumeDesktopMenus() {
    this.desktopMenusSuppressed = false;
  }

  openAboutDialog() {
    this.aboutTriggerElement = document.activeElement as HTMLElement;
    this.closeMobileMenu(false);
    if (window.innerWidth >= 1100) {
      this.closeDesktopMenus();
    }

    this.aboutDialogRef = this.dialog.open(this.aboutDialog, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      ariaLabelledBy: 'about-dialog-title',
      backdropClass: 'about-dialog-backdrop',
      panelClass: 'about-dialog-panel',
      enterAnimationDuration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? '0ms' : '180ms',
      exitAnimationDuration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? '0ms' : '180ms'
    });
    this.aboutDialogRef.afterClosed().subscribe(() => {
      this.resumeDesktopMenus();
      if (this.aboutTriggerElement && this.aboutTriggerElement.isConnected) {
        this.aboutTriggerElement.focus();
      }
      this.aboutTriggerElement = null;
    });
  }

  closeAboutDialog() {
    if (this.aboutDialogRef) {
      this.aboutDialogRef.close();
    }
  }

  private resetMobileMenu() {
    this.isExpanded = false;
    this.expandedMenuItems.clear();
    this.setPageScrollLocked(false);
  }

  private setPageScrollLocked(locked: boolean) {
    const action = locked ? 'add' : 'remove';
    document.body.classList[action]('mobile-navigation-open');
    document.documentElement.classList[action]('mobile-navigation-open');
  }

  private expandActiveMenuGroups() {
    this.expandedMenuItems.clear();
    this.expandActiveMenuGroup(this.navMenuList || []);
  }

  private expandActiveMenuGroup(items: NavEntity[]) {
    const activeItem = items.find(item => !item.hidden && this.isMenuActive(item));
    if (activeItem && this.hasVisibleSubmenu(activeItem)) {
      this.expandedMenuItems.add(activeItem);
      this.expandActiveMenuGroup(this.filterMenuItems(activeItem.submenu));
    }
  }

  private findMenuSiblings(items: NavEntity[], target: NavEntity): NavEntity[] {
    if (items.indexOf(target) !== -1) {
      return items;
    }

    for (const item of items) {
      if (item.submenu) {
        const siblings = this.findMenuSiblings(item.submenu, target);
        if (siblings) {
          return siblings;
        }
      }
    }

    return null;
  }

  private removeExpandedDescendants(item: NavEntity) {
    this.filterMenuItems(item.submenu || []).forEach(child => {
      this.expandedMenuItems.delete(child);
      this.removeExpandedDescendants(child);
    });
  }

  isMenuExpanded(item: NavEntity): boolean {
    return this.expandedMenuItems.has(item);
  }

  getIcon(item: NavEntity): string {
    if (item.icon) {
      return item.icon;
    }

    const searchText = `${item.header || ''} ${item.tooltip || ''}`.trim();
    const match = this.iconByKeyword.find(([keyword]) => keyword.test(searchText));
    return match ? match[1] : 'fiber_manual_record';
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (window.innerWidth >= 1100) {
      this.resetMobileMenu();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.isExpanded) {
      this.closeMobileMenu();
    }
  }

  hasVisibleSubmenu(item: NavEntity): boolean {
    return item.header?.toLowerCase() === 'sniper' ||
      (!!item.submenu && this.filterMenuItems(item.submenu).length > 0);
  }

  isMenuActive(item: NavEntity): boolean {
    if (item.link && item.link !== '#' && this.isRouteActive(item.link)) {
      return true;
    }

    return !!item.submenu && item.submenu.some(child => !child.hidden && this.isMenuActive(child));
  }

  isRouteActive(link: string): boolean {
    if (!link || link === '#') {
      return false;
    }

    const routePath = this.normalizePath(link);
    const currentPath = this.normalizePath(this.currentUrl.split(/[?#]/)[0]);
    return routePath === currentPath || (routePath !== '/' && currentPath.startsWith(`${routePath}/`));
  }

  private normalizePath(path: string): string {
    const normalized = `/${(path || '').replace(/^\/+|\/+$/g, '')}`;
    return normalized === '/' ? normalized : normalized.toLowerCase();
  }

  send_LoginAccion(idAccion: number) {
    this.HomeMenu_LoginAccion_prm.emit(idAccion);
  }


  Set_HomeMenuXRol(IdRol: number) {
    // if (IdRol === 0) {
    //   document.getElementById("btn_homemenu_sniper").style.display = "none";
    //   document.getElementById("btn_homemenu_nomina").style.display = "none";
    //   document.getElementById("btn_homemenu_novedades").style.display = "none";
    //   document.getElementById("btn_homemenu_reportes").style.display = "none";
    // }
    // if (IdRol == 1) {
    //   document.getElementById("btn_homemenu_sniper").style.display = "block";
    //   document.getElementById("btn_homemenu_nomina").style.display = "block";
    //   document.getElementById("btn_homemenu_novedades").style.display = "block";
    //   document.getElementById("btn_homemenu_reportes").style.display = "block";
    // }

    // if (IdRol == 2) {
    //   document.getElementById("btn_homemenu_sniper").style.display = "none";
    //   document.getElementById("btn_homemenu_nomina").style.display = "block";
    //   document.getElementById("btn_homemenu_novedades").style.display = "block";
    //   document.getElementById("btn_homemenu_reportes").style.display = "none";
    // }
  }

  HomeMenu_ComponentShow_void(component: string) {
    this.HomeMenu_ComponentShow_prm.emit(component);
  }

  cerrarSesion() {
    this.closeMobileMenu();
    // Detener la conexión SignalR al cerrar sesión
    this._userHubService.closeConnection(this.userValuesService.getUsuarioValues.userHubId).then(() => {
      // Realizar acciones adicionales después de detener la conexión
      console.log('Conexión SignalR detenida');
    }).catch((err: any) => console.error('Error al detener la conexión SignalR', err));

    // Cerrar sesión en el servicio de valores de usuario
    this.userValuesService.setLogout();
  }

  filterMenuItems(menuItems) {
    return menuItems.filter(x => !x.hidden);
  }
}
